"use client";

import { useLiveData } from "@/contexts/LiveDataContext";
import { useCurrency } from "@/contexts/CurrencyContext";
import CurrencyDropdown from "@/components/ui/CurrencyDropdown";

export default function LivePriceBox(): React.ReactElement {
  const { liveData } = useLiveData();
  const { convertUsd, currencySymbol } = useCurrency();

  const pct = liveData?.usd_price_24h_change_percentage ?? 0;
  const changeAmt = liveData ? liveData.usd_price - liveData.usd_price / (1 + pct / 100) : 0;
  const convertedChangeAmt = convertUsd(changeAmt);
  const isPositive = pct >= 0;

  return (
    <div className="inline-flex w-full relative p-[22px] flex-col items-end gap-[9px] border border-foreground/7 bg-foreground/4 __backdrop-blur-[62px] box-border overflow-hidden max-h-[180px] font-kode-mono">
      <div className="absolute blur-[62px] bottom-2 left-1/2 -translate-x-1/2 w-[220px] h-[40.67px] bg-accent-gold/28 rounded-full" />
      <div className="flex justify-between items-center w-full pb-[13px] relative after:absolute after:bottom-0 after:left-0 after:right-0 after:h-px after:opacity-5 after:bg-[linear-gradient(90deg,rgba(255,255,255,0.30)_0%,#FFF_46.63%,rgba(255,255,255,0.30)_100%)]">
        <span className="text-accent-light-title text-[14px] font-kode-mono font-normal leading-normal tracking-[-0.28px]">
          ZEC Live Price
        </span>
        <CurrencyDropdown />
      </div>
      <div className="w-full">
        <div className="flex items-end overflow-hidden min-h-[41px]">
          <span className="text-white text-[15px] font-medium font-rubik mr-[4px] mb-3.5 shrink-0">
            {currencySymbol}
          </span>
          <span className="text-white text-[34px] font-medium leading-normal font-rubik tabular-nums min-w-[5ch]">
            {liveData ? convertUsd(liveData.usd_price).toFixed(2) : "—"}
          </span>
        </div>
        <div className="flex justify-between items-center mt-[5px]">
          <span
            className={`${isPositive ? "text-accent-green" : "text-accent-red"} text-[14px] font-kode-mono font-medium leading-[160%]`}
            style={{ fontFeatureSettings: "'salt' on, 'liga' off" }}
          >
            {liveData
              ? `${isPositive ? "+" : ""}${convertedChangeAmt.toFixed(2)} (${isPositive ? "+" : ""}${pct.toFixed(2)}%)`
              : "—"}
          </span>
        </div>
      </div>
    </div>
  );
}
